var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3790_54057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 6C9.788 6 6 6.35544 6 7.6875V16.3096C6.00077 17.6413 9.77223 18 12 18C14.2278 18 17.9992 17.6451 18 16.3096V7.65234C17.9274 6.35109 14.2118 6 12 6ZM12 6.76367C15.108 6.76367 16.9842 7.34736 17.2002 7.66797C16.9922 8.00003 15.116 8.58008 12 8.58008C10.5145 8.6154 9.03135 8.44101 7.59961 8.06152V8.8584C9.03865 9.19817 10.5177 9.36168 12 9.34375C13.6 9.34375 15.9722 9.16023 17.2002 8.58008V10.5381C17.0682 10.8663 15.176 11.4736 12 11.4736C10.5145 11.5095 9.03123 11.3341 7.59961 10.9541V11.748C9.03832 12.0899 10.5175 12.2539 12 12.2363C13.6 12.2363 15.9722 12.0538 17.2002 11.4736V13.4463C17.0682 13.7745 15.176 14.3818 12 14.3818C10.5137 14.4128 9.03042 14.2328 7.59961 13.8477V14.6416C9.03832 14.9835 10.5175 15.1474 12 15.1299C13.6 15.1299 15.9722 14.9464 17.2002 14.3662V16.3125C17.0602 16.6407 15.168 17.248 12 17.248C8.83297 17.248 6.92087 16.6265 6.7998 16.3096V7.70215C6.92002 7.38915 8.8002 6.76367 12 6.76367Z",
    fill: "#003771"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3790_54057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorage);
export default __webpack_public_path__ + "static/media/Storage.5330525d9ba5d5dfcafdc33bece9b6df.svg";
export { ForwardRef as ReactComponent };